var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isPhone
    ? _c("div", { staticClass: "mobile-links" }, [
        _c("div", { staticClass: "applications-wrapper" }, [
          _c("div", { staticClass: "header" }),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _vm.isGoogle
              ? _c("img", {
                  attrs: {
                    rel: "preload",
                    src: require("@/assets/images/mobile-google-play-badge.svg"),
                    alt: "Google",
                  },
                  on: { click: _vm.openApplication },
                })
              : _c("img", {
                  attrs: {
                    rel: "preload",
                    src: require("@/assets/images/mobile-app-store-badge.svg"),
                    alt: "Apple",
                  },
                  on: { click: _vm.openApplication },
                }),
          ]),
          _vm._v(" "),
          _vm._m(0),
        ]),
      ])
    : _c("div", [_vm._t("default")], 2)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "footer" }, [
      _c("img", {
        attrs: {
          rel: "preload",
          src: require("@/assets/images/home-ind-scm.svg"),
          alt: "Scm",
        },
      }),
      _vm._v(" "),
      _c("img", {
        attrs: {
          rel: "preload",
          src: require("@/assets/images/home-ind-cms.svg"),
          alt: "Cms",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }